<template>
    <div class="grid py-4 px-4 lg:px-8 relative" id="hero">
        <div class="mx-4 md:mx-8 mt-0 md:mt-4">
            <h1 class="text-6xl font-bold text-gray-900 line-height-2">
                <span class="font-light block">{{ setting.company_name }}</span>Human Resource System
            </h1>
            <p class="font-normal text-2xl line-height-3 md:mt-3 text-gray-700">
                Ultimate Assets Protection
            </p>
            <Button label="Get Started"
                class="p-button-rounded text-xl border-none mt-5 bg-blue-500 font-normal text-white line-height-3 px-3"></Button>
        </div>
        <img src="images/screen-1.png" class="bottom-0" alt="hero screen" style="right: 10%" />
    </div>
    <div class="py-4 px-4 lg:px-8 mx-0 my-3 lg:mx-6">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="text-center">Karir</h1>
                    <p class="text-center">Kami selalu mencari orang yang bertalenta untuk bergabung dengan tim kami. Jika tertarik untuk bergabung dengan kami, silahkan kirimkan lamaran ke : <a :href="'mailto:' + setting.company_email">{{ setting.company_email }}</a></p>
                </div>
            </div>
        </div>
    </div>
    <div class="py-4 px-4 lg:px-8 mx-0 my-3 lg:mx-6">
        <Card class="mt-3" v-for="model in models" v-bind:key="model.id">
            <template v-slot:title>
                <div class="flex align-items-center justify-content-between mb-0">
                    <h5>
                        <Link :href="/careers/+model.id">
                            {{ model.name }}
                        </Link>
                    </h5>
                    <h6>{{ model.updated_at }}</h6>
                </div>
            </template>
            <template v-slot:content>
                <p class="line-height-3 m-0"><span v-html="model.description"></span></p>
                <div class="align-items-right justify-content-center mt-3">
                    <Button @click="detail(model.id)" type="submit" label="Apply Now" class="p-3"></button>
                </div>
            </template>
        </Card>
    </div>
</template>
<script>
import Button from "primevue/button";
import Card from "primevue/card";
import DatatableService from "../../Services/DatatableService";
import { Link } from "@inertiajs/inertia-vue3";
import Divider from "primevue/divider";
import LandingLayout from "../../Layouts/LandingLayout";
export default {
    layout: LandingLayout,
    components: {
        Button,
        Divider,
        Card,
        Link,
    },
    data() {
        return {
            models: {},
            setting: this.$page.props.setting.data,
            datatableService: {},
            setting: this.$page.props.setting.data,
        }
    },
    created(){
        this.datatableService = new DatatableService();
        this.loadData();
    },
    methods:{
        loadData(){
            this.datatableService
                .getData('api/careers')
                .then((data) => {
                    this.models = data.data;
                });
        },
        detail(id){
            this.$inertia.get('/careers/'+id);
        },
    }
}
</script>
